interface TripAddv4 {
  breakdown?: {
    authorizedBalanceDue: number;
  };
  journeys?: any[];
}

interface CreateTripObject {
  tripAddv4?: TripAddv4;
}

interface ResponseData {
  status: boolean;
  code?: number;
  message?: string;
  data: {
    onlyFlightCost: number;
    journeys?: any[];
  };
}

export function createTripObjectRefine(createTripObject?: CreateTripObject): ResponseData {
  try {
    const responseData: ResponseData = {
      status: true,
      data: {
        onlyFlightCost: 0
      }
    };
    if (createTripObject && createTripObject.tripAddv4?.breakdown) {
      responseData.data.onlyFlightCost = createTripObject.tripAddv4.breakdown.authorizedBalanceDue;
      responseData.data.journeys = createTripObject.tripAddv4.journeys;
    }
    return responseData;
  } catch (error) {
    const responseData: ResponseData = {
      status: false,
      code: 500,
      message: "Something went wrong",
      data: {
        onlyFlightCost: 0
      }
    };
    return responseData;
  }
}
